import React from 'react';
import { useTranslation } from 'react-i18next';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { URLS } from '@wix/da-url';
import s from './StepThree.scss';

const StepThree: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className={s['container']}>
      <main>
        <p className={s['message']}>
          {t('report.success.message', {
            postProcess: ['reactPostprocessor', 'featureBrancher'],
            br: <br />,
          })}
        </p>
        <GhostButton
          variant="main"
          size="large"
          href={`${URLS.SETTINGS_GENERAL}#blocked_users`}
        >
          {t('report.success.blockDeviant')}
        </GhostButton>
      </main>
    </section>
  );
};

export default StepThree;
